import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UserDTO } from '../common/user.service';
import { Product } from '../product/product.service';

export interface ProgramContactDTO {
    user: UserDTO;
    role: string;
    fte: number;
}


export interface DeploymentGateDTO {
  id?: number;
  name: string;
  weight: number;
  comment?: string;
  creationDate?: Date;
  hasDeploymentGroups: boolean;
}

export interface ProgramDTO {
  id: number;
  name: string;
  trigram: string;
  ambition: string;
  partnerCompany: string;
  entityOwner: string;
  entityOwnerId?: number;
  progress: number;
  branches: string[];
  scopes?: any[];
  contacts: ProgramContactDTO[];
  deploymentGates?: DeploymentGateDTO[];
  product?: Product;
  workstreams: any[];
}


@Injectable({
  providedIn: 'root'
})
export class ProgramService {
  private readonly apiUrl = `${environment.webProtocol}://${environment.serverUrl}/api/programs`;

  constructor(private readonly http: HttpClient) { }

  saveProgram(program: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/save`, program);
  }

  getProgram(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  getAllProgramIdAndNamesAndFamily(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/id-and-names-and-family`);
  }

  getAllProgramTrigrams(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/trigrams`);
  }
  
  getAllPrograms(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}`);
  }

  getProductsForProgram(programId?: number): Observable<any[]> {
    let url = `${this.apiUrl}/products-for-program`;
    if (programId) {
      url += `?programId=${programId}`;
    }
    return this.http.get<any[]>(url);
  }

  getAssignedProductsForProgram(programId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/assigned-products-for-program?programId=${programId}`);
  }

  getLbusForProgram(programId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/lbus-for-program?programId=${programId}`);
  }

  getEnablerProjectsForProgram(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/enabler-projects-for-program`);
  }

  isSingleProductProgram(program: ProgramDTO): boolean {
    return Array.isArray(program.deploymentGates) && program.deploymentGates.length > 0;
  }

  updateDeploymentGateComments(comments: { [gateId: number]: string }): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/deployment-gate/comments`, comments);
  }
  
  getProgramWorkstreams(programId: number): Observable<any[]> {
    const httpParams = new HttpParams().set('programId', programId.toString());
    return this.http.get<any[]>(`${this.apiUrl}/workstreams`, { params: httpParams });
  }
}
